import MaterialReactTable, { MaterialReactTableProps } from "material-react-table"
import { StrictOmit } from "../../../lib/lang"
import { useSelector } from "react-redux"
import { selectSelectedLocale } from "../localizationSelectors"
import { useMemo } from "react"
import { getMaterialReactTableTranslation } from "../localizationLib"

type Props<TData extends Record<string, any>> = StrictOmit<MaterialReactTableProps<TData>, "localization">

export function LocalizedMaterialReactTable<TData extends Record<string, any> = {}>(props: Props<TData>) {
    const selectedLocale = useSelector(selectSelectedLocale)
    const translation = useMemo(() => getMaterialReactTableTranslation(selectedLocale), [selectedLocale])

    return (
        <MaterialReactTable localization={translation} {...props} />
    )
}
